import BuildIcon from '@/components/Theme03/Icons/BuildIcon'
import HouseIcon from '@/components/Theme03/Icons/HouseIcon'
import OfficeIcon from '@/components/Theme03/Icons/OfficeIcon'
import MapIcon from '@/components/Theme03/Icons/MapIcon'
import StoreIcon from '@/components/Theme03/Icons/StoreIcon'
import CoconutIcon from '@/components/Theme03/Icons/CoconutIcon'
import CartIcon01 from '@/components/Theme01/Icons/CartIcon01'
import CartShopIcon01 from '@/components/Theme01/Icons/CartShopIcon01'
import BagIcon from '@/components/Theme01/Icons/BagIcon'

export const icons = {
  BuildIcon,
  HouseIcon,
  OfficeIcon,
  MapIcon,
  StoreIcon,
  CoconutIcon,
  CartIcon01,
  CartShopIcon01,
  BagIcon
}

export const alias = [
  'BuildIcon',
  'HouseIcon',
  'OfficeIcon',
  'MapIcon',
  'StoreIcon',
  'CoconutIcon',
  'CartIcon01',
  'CartShopIcon01',
  'BagIcon'
]
